import { formatDepositAmount } from "@/client/money";
import type { DepositItem } from "@/client/types";
import { MinusIcon, PlusIcon } from "@/components/icons";

type DepositCatalogProps = {
  items: DepositItem[];
  currency: string;
  onQuantityChange: (id: string, quantity: number) => void;
  onAddSampleItems: () => void;
};

export function DepositCatalog({
  items,
  currency,
  onQuantityChange,
  onAddSampleItems,
}: DepositCatalogProps) {
  const activeItems = items.filter((item) => item.enabled);
  if (activeItems.length === 0) {
    return (
      <section className="empty-catalog" aria-live="polite">
        <div className="empty-illustration">↺</div>
        <h2>Der Pfandkatalog ist leer</h2>
        <p>Lege in den Einstellungen eigene Artikel für diese Kasse an.</p>
        <button
          className="button button-secondary"
          type="button"
          onClick={onAddSampleItems}
        >
          Katalog öffnen
        </button>
      </section>
    );
  }

  return (
    <section className="catalog-grid" aria-label="Pfandartikel">
      {activeItems
        .sort((left, right) => left.sortOrder - right.sortOrder)
        .map((item) => (
          <article
            className={`deposit-card ${item.quantity > 0 ? "is-selected" : ""}`}
            key={item.id}
          >
            <div className="card-topline">
              <span className="sku">{item.sku}</span>
            </div>
            <h2>{item.name}</h2>
            <p className="deposit-value">
              {formatDepositAmount(item.depositCents, currency)}{" "}
              <span>je Stück</span>
            </p>
            <fieldset
              className="quantity-control"
              aria-label={`Menge ${item.name}`}
            >
              <button
                aria-label={`${item.name} verringern`}
                type="button"
                disabled={item.quantity === 0}
                onClick={() => onQuantityChange(item.id, item.quantity - 1)}
              >
                <MinusIcon />
              </button>
              <strong>{item.quantity}</strong>
              <button
                aria-label={`${item.name} erhöhen`}
                type="button"
                onClick={() => onQuantityChange(item.id, item.quantity + 1)}
              >
                <PlusIcon />
              </button>
            </fieldset>
          </article>
        ))}
    </section>
  );
}
